import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import apiClient from '../api/apiClient';
import { ROLES } from '../utils/roles';
import './DashboardPage.css';

const DashboardPage = () => {
  const { user } = useAuth();
  
  const [data, setData] = useState({
    stats: { hold: 0, censorer: 0 },
    notifications: [],
    censorStatus: { godkendt: false, terminNavn: '' }
  });
  const [loading, setLoading] = useState(true);

  // Funktion til at hente data
  const fetchDashboard = async () => {
    try {
      const res = await apiClient.get('/api/dashboard/overview');
      setData(res.data);
    } catch (err) { console.error(err); } 
    finally { setLoading(false); }
  };

  useEffect(() => {
    if (user) fetchDashboard();
  }, [user]);

  // Håndter klik på godkend
  const handleApprove = async () => {
    if(!window.confirm(`Er du sikker på, at alle censoroplysninger er korrekte for ${data.censorStatus.terminNavn}?`)) return;
    
    try {
        await apiClient.post('/api/dashboard/approve-censors');
        // Opdater kun den specifikke del af state for hurtig respons
        setData(prev => ({
            ...prev,
            censorStatus: { ...prev.censorStatus, godkendt: true }
        }));
        alert('Tak! Din godkendelse er registreret.');
    } catch(err) {
        alert('Der skete en fejl.');
    }
  };

  return (
    <div>
      {/* 1. NOTIFIKATIONER */}
      {/*<div style={{marginBottom: '2rem'}}>
        {data.notifications.map(note => (
          <div key={note.id} className={`notification-card notify-${note.type}`}>
            <div className="notify-title">
              {note.type === 'success' && '✅'}
              {note.type === 'warning' && '⚠️'}
              {note.type === 'info' && 'ℹ️'}
              {note.title}
            </div>
            <div className="notify-message">{note.message}</div>
          </div>
        ))}
      </div>*/}

      <div className="dashboard-grid">
        
        {/* STATISTIK KORT (Eksisterende) */}
        {/*<div className="dashboard-card">
          <div>
            <h3 className="card-title">Aktive Hold</h3>
            <p className="stat-value">{loading ? '-' : data.stats.hold}</p>
          </div>
          <p className="stat-desc">Denne termin</p>
        </div>*/}

        <div className="dashboard-card">
          <div>
            <h3 className="card-title">Tilmeldte Censorer</h3>
            <p className="stat-value">{loading ? '-' : data.stats.censorer}</p>
          </div>
          <p className="stat-desc">Total i systemet</p>
        </div>

      </div>
    </div>
  );
};

export default DashboardPage;